import { useEditor, useEditorApi } from "./store";

/** Speaker notes of the open page (shown in the speaker view while presenting). */
export function PageNotes() {
  const store = useEditorApi();
  const pageIndex = useEditor((s) => s.pageIndex);
  const page = useEditor((s) => s.doc.pages[s.pageIndex]);
  const readOnly = useEditor((s) => s.readOnly);
  if (!page) return null;
  if (readOnly && !page.notes) return null;
  return (
    <div className="space-y-1">
      <label htmlFor={`notes-${page.id}`} className="text-xs text-zinc-500">
        Notizen für die Präsentation
      </label>
      <textarea
        id={`notes-${page.id}`}
        value={page.notes ?? ""}
        readOnly={readOnly}
        rows={3}
        maxLength={10000}
        placeholder="Nur in der Referentenansicht sichtbar"
        onChange={(event) => {
          const value = event.target.value;
          store.getState().update(
            (draft) => {
              const target = draft.pages[pageIndex];
              if (!target) return;
              if (value) target.notes = value;
              else delete target.notes;
            },
            { merge: `notes-${page.id}` },
          );
        }}
        className="w-full resize-y rounded-md border border-zinc-200 px-2 py-1.5 text-xs text-zinc-800 placeholder:text-zinc-400 focus:border-brand-500 focus:outline-none"
      />
    </div>
  );
}
